module.exports = __webpack_public_path__ + "img/cloud-bottom-left-desktop.df540f3.png";